import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";

export const ListAnalyticsSearches = graphql(/* GraphQL */ `
	query ListAnalyticsSearches($params: ListAnalyticsSearchesParams!) {
		listAnalyticsSearches(params: $params) {
			gid
			location_name
			updated
			search_params {
				after
				asset_set_id
				before
				relative_timestamp {
					offset
					timezone
				}
				incident_types
				keywords
				longkey
				severities
				geo_filter {
					radius_km
					geometry {
						type
						point
						polygon
					}
				}
			}
		}
	}
`);

export const recentSearchCount = 10;

export function useListAnalyticsSearches() {
	const { data, loading, error, refetch } = useQuery(ListAnalyticsSearches, {
		variables: {
			params: { count: recentSearchCount },
		},
	});

	return {
		searches: data?.listAnalyticsSearches ?? undefined,
		loading,
		error,
		refetch,
	};
}

export type RecentAnalyticsSearch = NonNullable<
	ReturnType<typeof useListAnalyticsSearches>["searches"]
>[number];
